import Cookies from "js-cookie";
import { networkUrls } from "../services/networkurls";

export const getHeaderText = (type: any,category?:any) => {
  let text = "";
  if (type === "logout") {
    text = "Are you sure you want to logout?";
  } else if (type === "delete" ) {
    text = "Are you sure you want to delete?";
   
  }else if(type==="drive-access"){
    text="Do you want access to the Case Study Google Drive folder?"
  }
  else if(type==="drive-access-success"){
    text="Drive access granted successfully"
  }

  else if(type==="drive-access-failure"){
    text="Failed to grant Drive access"
  }
   else if(type==="missing-category"){
      text = category
    }

    else if(type==="delete-session"){
      text="Are you sure you want to delete this session?"
    }
  else{
    text="Deleting this tag will unlink it from all associated projects. Are you sure you want to proceed?"
    text = text.replace(
      "unlink it from all associated projects",
      '<span style="color: red;">unlink it from all associated projects</span>'
    );
  }

  return text;
};

export const getButtonText = (type: any) => {
  let text = "";
  if (type === "logout") {
    text = "Logout";
  } else if (type === "delete") {
    text = "Delete";
  }else if (type==="missing-category"){
    text="Proceed"
  }else if(type==="drive-access" || type==="drive-access-success" ){
    text="Yes"
  }else if(type==="delete-session"){
    text="Delete"
  }

  return text;
};



const removeClientSideStorage=()=>{
      Cookies.remove("refreshToken");
      localStorage.removeItem("userDetails");
      Cookies.remove("expiryTime");
      Cookies.remove("selectedCategory")
      Cookies.remove("accessToken")
      localStorage.removeItem("ai_chat_messages");
}
export default removeClientSideStorage;

